import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { Subject } from 'rxjs';

import { NoCreditWarningDialogComponent, NoCreditDialogData } from './no-credit-warning-dialog.component';

@Injectable()
export class NoCreditWarningDialogService {

  private readonly defaultConfigs: MatDialogConfig = {
    width: '600px',
    disableClose: true
  };

  constructor(private matDialog: MatDialog) { }

  /**
   * Shows no credit warning dialog
   * @method showNoCreditWarning
   */
  showNoCreditWarning(dialogData: NoCreditDialogData): Subject<string> {
    const matDialog: MatDialogRef<NoCreditWarningDialogComponent> = this.matDialog.open(NoCreditWarningDialogComponent, {
      ...this.defaultConfigs,
      data: dialogData
    });

    return matDialog.componentInstance.dialogAction;
  }
}
